import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Core components
import Select from 'components/core/Select';
import TextField from 'components/core/TextField';
// Models
import mEquipment from 'models/equipment';
import { virtualTriggerEthernet } from 'models/device';
// Custom
import { equipmentDataShape } from 'constants/PropTypesShapes';
import { buildFormErrors, ethernetEquipmentConstraints } from 'utils/Forms';
import withFormManagement from 'hocs/WithFormManagement';
import SubFormTemplate from 'components/templates/SubFormTemplate';
import AppIcon from 'components/icons/AppIcon';

class ConfigureDeviceSlaveTriggerEthernetAddEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleEquipmentChange = this.handleEquipmentChange.bind(this);
    this.handleValidate = this.handleValidate.bind(this);
  }

  // Handlers
  handleEquipmentChange(id) {
    const { onFieldsChange } = this.props;
    let newFields = { id };
    if (!id) {
      newFields = {
        ...newFields,
        name: '',
        mac: '',
        ip: '',
      };
    }
    onFieldsChange(newFields);
  }

  handleValidate() {
    const {
      fields: {
        id, name, mac, ip,
      },
      equipments, onErrorsChange, onValidate,
    } = this.props;

    // Check form
    const errors = buildFormErrors({ name, mac, ip }, ethernetEquipmentConstraints);
    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      // Build equipment with name and ip
      const equipment = _find(equipments, ['id', id]);
      onValidate({
        ...equipment,
        name,
        mac,
        ip,
      });
    }
  }

  render() {
    const {
      fields: {
        id, name, mac, ip,
      }, errors,
      parentErrors, equipment, equipments, onFieldsChange, onCancel,
    } = this.props;

    const actionType = equipment ? 'edit' : 'add';
    const filteredEquipments = mEquipment.sortElements(_filter(equipments, (eq) => (_includes(virtualTriggerEthernet.protocols, eq.protocol))));

    return (
      <SubFormTemplate
        title={<LocalizedMessage id={`title.${actionType}Equipment`} />}
        errors={errors || parentErrors}
        onCancel={onCancel}
        onValidate={this.handleValidate}
      >
        <div className="row">
          <div className="col-12 col-md-6 col-xl-3">
            <Select
              label={<LocalizedMessage id="field.equipment" />}
              value={id}
              items={
                _map(filteredEquipments, (eq) => ({
                  key: _toString(eq.id),
                  value: eq.id,
                  label: `${eq.brand} ${eq.model} (${eq.protocol})`,
                  icon: <AppIcon defaultColor id={mEquipment.type(eq).icon} />,
                }))
              }
              required
              onChange={this.handleEquipmentChange}
              withNullItem
            />
          </div>
          <div className="col-12 col-md-6 col-xl-3">
            <TextField
              label={<LocalizedMessage id="field.name" />}
              disabled={!id}
              value={name}
              required
              errorText={_get(errors, 'name')}
              onChange={(value) => onFieldsChange({ name: value })}
            />
          </div>
          <div className="col-12 col-md-6 col-xl-3">
            <TextField
              label={<LocalizedMessage id="field.macAddress" />}
              disabled={!id}
              value={mac}
              required
              errorText={_get(errors, 'mac')}
              onChange={(value) => onFieldsChange({ mac: value })}
            />
          </div>
          <div className="col-12 col-md-6 col-xl-3">
            <TextField
              label={<LocalizedMessage id="field.ipAddress" />}
              disabled={!id}
              value={ip}
              required
              errorText={_get(errors, 'ip')}
              onChange={(value) => onFieldsChange({ ip: value })}
            />
          </div>
        </div>
      </SubFormTemplate>
    );
  }
}

ConfigureDeviceSlaveTriggerEthernetAddEditForm.propTypes = {
  equipment: equipmentDataShape,
  parentErrors: PropTypes.shape({
    global: PropTypes.string.isRequired,
  }),
  equipments: PropTypes.arrayOf(equipmentDataShape),
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

ConfigureDeviceSlaveTriggerEthernetAddEditForm.defaultProps = {
  equipment: null,
  parentErrors: null,
  equipments: null,
  errors: null,
};

const mapStateToProps = (state) => ({
  equipments: state.equipment.list.elements.data,
});

const mapFieldsToProps = {
  id: {
    resourceKey: 'id',
    defaultValue: null,
  },
  name: {
    resourceKey: 'name',
    defaultValue: '',
  },
  mac: {
    resourceKey: 'mac',
    defaultValue: '',
  },
  ip: {
    resourceKey: 'ip',
    defaultValue: '',
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: ownProps.equipment,
});

module.exports = compose(
  connect(
    mapStateToProps,
    null,
  ),
  withFormManagement(mapFieldsToProps, mapOwnPropsToResources, false),
)(ConfigureDeviceSlaveTriggerEthernetAddEditForm);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/configuration/ConfigureDeviceSlaveTriggerEthernetAddEditForm.js